import Icon from '@mdi/react';
import { mdiChatOutline, mdiOpenInNew, mdiWalletGiftcard, mdiWeb } from '@mdi/js';

const StaticMenuItems = () => {
    return (
        <ul>
            <li>
                <a
                    href='https://www.transport.se'
                    className='nav-link'
                    target='_blank'
                    rel='noreferrer'
                >
                    <Icon
                        path={mdiWeb}
                        className='mdi mr-2'
                    />
                    transport.se
                </a>
            </li>
            <li>
                <a
                    href='https://kundo.se/org/svenska-transportarbetareforbundet-0syr/'
                    className='nav-link'
                    target='_blank'
                    rel='noreferrer'
                >
                    <Icon
                        path={mdiChatOutline}
                        className='mdi mr-2'
                    />
                    Medlemsforum
                </a>
            </li>
            <li>
                <a
                    href='https://lomervarde.se/'
                    className='nav-link'
                    target='_blank'
                    rel='noreferrer'
                >
                    <Icon
                        path={mdiWalletGiftcard}
                        className='mdi icon mr-2'
                    />
                    Förmåner
                </a>
            </li>
            <li>
                <a
                    href='https://www.transport.se/integritet/vi-tar-hand-om-dina-personuppgifter/'
                    className='nav-link'
                    target='_blank'
                    rel='noreferrer'
                >
                    <Icon
                        path={mdiOpenInNew}
                        className='mdi icon mr-2'
                    />
                    Behandling av personuppgifter
                </a>
            </li>
        </ul>
    );
};

export default StaticMenuItems;
